import {initRepoSettingsBranchesDrag} from '../../js/features/repo-settings-branches.ts';
import {initUserAuthSAML} from './features/user-auth.ts';
import {initAuditLogFilter} from './features/admin/audit.ts';
import {initGlobalAnnouncement} from './features/admin/announcement.ts';
import {initAdminDevopsDashboardConfig} from './features/admin/devops-dashboard-config.ts';
import {initDevopsDashboard} from './features/devops-dashboard.ts';
import {initRepoSettingsSecurity} from './features/repo-settings-security.ts';
import {initRepoSettingsUserGroups} from './features/repo-settings-user-groups.ts';
import {initCompSearchUserGroupBox} from './features/user-group-selector.ts';

export function initEE() {
  initRepoSettingsBranchesDrag(); // for org protected branches drag and drop

  initUserAuthSAML();
  initAuditLogFilter();
  initGlobalAnnouncement();
  initAdminDevopsDashboardConfig();
  initDevopsDashboard();
  initRepoSettingsSecurity();
  initRepoSettingsUserGroups();
  initCompSearchUserGroupBox();
}
